import React, { Component } from "react";
import { Link } from 'react-router-dom';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
const logoUrl = <img src="/assets/images/logo/logo.png" alt="Digital Agency" />;

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class Footer extends Component{
    render(){
        return(
            <React.Fragment>
                <footer className="footer-area footer-style-01 bg_color--4">
                    {/* Start Call to Action Area  */} 
                    {/*  <div className="im-call-to-action-area ptb--70 im-separator">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-8 col-xl-6 col-md-12 col-sm-12 col-12">
                                    <div className="inner">
                                        <h2 className="text-white mb--0">Enough Talk, Let's Build Something Together</h2>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-xl-4 offset-xl-2 col-md-12 col-sm-12 col-12">
                                    <div className="call-to-cation-tbn text-left text-lg-right mt_md--20 mt_sm--20">
                                        <a className="btn-default btn-large btn-border btn-opacity" href="#button">Read Out Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    {/* End Call to Action Area  */}

                    {/* Start Footer Area  */}
                    <div className="footer-wrapper ptb--70">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                    <div className="ft-text">
                                        <div className="logo thumbnail">
                                            <Link to="/">
                                                {logoUrl}
                                            </Link>
                                            <br/>
                                            <p>We team LEONART paves the way to structure, design, present, establish our responsibility in the multicolored canvas of technology and expertise in the suitable and apt position and period.</p>

                                        </div>
                                        <p>Copyright © 2023 Leonart Advt Pvt Ltd. All Rights Reserved.</p>
                                    </div>
                                </div>
                                
                                {/* Start Single Widget  */}
                                <div className="col-lg-2 col-xl-2 offset-xl-1 col-md-6 col-sm-6 col-12 mt_mobile--40">
                                    <div className="footer-link">
                                        <h4>Portfolio</h4>
                                        <ul className="ft-link">
                                            <li><Link to="/package-des">Mockups</Link></li>
                                            <li><Link to="/brochure-design">Brochures</Link></li>
                                            <li><Link to="/corporate-logo">Logos</Link></li>
                                            <li><Link to="/web-design">Web Design</Link></li>
                                            <li><Link to="/Socialmediaposter">Social Media Posts</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* End Single Widget  */}

                                {/* Start Single Widget  */}
                                <div className="col-lg-2 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40">
                                    <div className="footer-link">
                                        <h4>Company</h4>
                                        <ul className="ft-link">
                                            <li><Link to="/aboutus">About</Link></li>
                                            <li><Link to="/services">Services</Link></li>
                                            <li><Link to="/gallery">Gallery</Link></li>
                                            <li><Link to="/career">Careers</Link></li>
                                            <li><Link to="/contact">Contact</Link></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* End Single Widget  */}

                                {/* Start Single Widget  */}
                                <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40">
                                    <div className="footer-link">
                                        <h4>Say Hello</h4>
                                        <ul className="ft-link">
                                            <li>Email: <a href="mailto:info@leonart.co">info@leonart.co</a></li>
                                            <li>Phone: <a href="mailto:hr@example.com">+91 9539 56 9539</a></li>
                                            <li>Phone: <a href="mailto:hr@example.com">+91 8921 42 7252</a></li>

                                        </ul>

                                        <div className="social-share-inner mt--20">
                                            <ul className="social-share social-style--2 d-flex justify-content-start liststyle">
                                                {SocialShare.map((val , i) => (
                                                    <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                                ))}
                                            </ul>
                                        </div> 
                                    </div>
                                </div>
                                {/* End Single Widget  */}

                   
                            </div>

             




                        </div>
                    </div>
                    {/* End Footer Area  */}
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;